// http://0.0.0.0:9444/help/~export
module.exports = {
    articles: {
        "text.editor.shortcuts": "general/keyboard-shortcuts#text-editor",
        "my_work.view_for": "my_work/view_for",
        "text.editor": "text-editor",
        "customization.project_types": "project-types-customization",
        "automations.overview": "automations/overview",
        "chat.overview": "chat/overview",
        "notes.overview": "notes/overview",
        "request_forms.overview": "request-forms/overview",
        "workload": "workload",


        // this is old
        "my_work.overview": "my_work/overview",
        "my_work.action_required": "my_work/action-required",
        "my_work.assigned": "my_work/assigned",
        "my_work.involved": "my_work/involved",
        "my_work.widgets": "my_work/widgets",
        "tasks.overview": "tasks/overview",
        "tasks.creating_a_task": "tasks/creating-a-task",
        "tasks.working_with": "tasks/working-with",
        "tasks.actions": "tasks/actions",
        "tasks.fields": "tasks/fields",
        "tasks.types": "tasks/types",
        "tasks.subtasks": "tasks/subtasks",
        "tasks.todo_list": "tasks/todo",
        "tasks.recurring": "tasks/recurring",
        "tasks.view_settings": "tasks/view-settings",
        "folders.overview_projects_folders": "folders/overview",
        "folders.project_structure": "project-structure",
        "folders.creating_a_project": "creating-a-project",
        "folders.project_fields_and_properties": "project-fields-and-properties",
        "folders.project_types": "project-types",
        "folders.manage": "managing-projects-folders",
        "folders.users_permissions": "users-permissions",
        "folders.project_settings": "projects/settings",
        "views.overview": "views/overview",
        "views.management": "views/management",
        "views.tasks_table": "views/tasks-table",
        "views.tasks_board": "tasks-board",
        "views.gantt": "gantt",
        "views.timeline": "timeline",
        "views.calendar": "views/calendar",
        "views.events_list": "events-list",
        "views.events_summary": "events-summary",
        "views.whats_done": "whats-done",
        "views.tasks_by_user": "views/tasks-by-user",
        "views.tasks_planning": "tasks-planning",
        "views.priorities": "views/priorities",
        "views.active_projects": "active-projects",
        "views.pastdue": "pastdue",
        "views.resource_planning": "resource_planning",
        "views.activity_stream": "activity-stream",
        "views.recent": "views/recent",
        "events.overview": "events/overview",
        "events.project_events": "project-events",
        "events.organization_events": "organization-events",
        "events.personal": "events/personal",
        "events.creating_an_event": "events/create",
        "events.managing_events": "events/management",
        "customization.task_types": "task-types-customization",
        "customization.note_types": "note-types-customization",
        "customization.custom_fields": "customization/custom-fields",
        "customization.statuses": "customization/statuses",
        "customization.priorities": "priorities",
        "users.invite": "users/invite",
        "users.roles_access": "users/roles-access",
        "users.managing_organization_users": "users/managing-organization-users",
        "users.organization_user_settings": "users/settings",
        "organization_management.multi_organization_support": "multiple-organization-support",
        "organization_management.create": "organizations/create",
        "organization_management.organization_settings": "organization/settings",
        "organization_management.departments": "users/departments",
        "organization_management.account_license_and_upgrade": "account-license-and-upgrade",
        "organization_management.administration": "organization/administration",
        "time_tracking.overview": "time/overview",
        "time_tracking.time_reporting": "time/reporting",
        "time_tracking.timer": "time/timer",
        "time_tracking.guesstimate": "time/guesstimates",
        "time_tracking.my_time": "my-time",
        "time_tracking.analytics": "time/analytics",
        "my_account.overview": "overview-my-account",
        "my_account.profile": "profile",
        "my_account.datetime": "datetime",
        "my_account.change_email": "my-account/email",
        "my_account.change_password": "my-account/password",
        "my_account.integrations": "my-account/integrations",
        "my_account.menu_settings": "my-account/menu",
        "big_screens.overview": "overview-big-screens",
        "big_screens.managing_devices": "managing-devices",
        "big_screens.managing_screens": "managing-screens",
        "big_screens.types_of_screens": "types-of-screens",
        "big_screens.launching_a_big_screen": "launching-a-big-screen",
        "notifications.overview": "notifications/overview",
        "notifications.goodday": "notifications/goodday",
        "notifications.email": "notifications/email",
        "notifications.desktop": "notifications/desktop",
        "notifications.mobile": "notifications/mobile",
        "other.dashboard": "dashboard",
        "other.pins": "pins",
        "other.starred": "other/starred",
        "other.search": "search",
        "other.import_from_csv": "import-from-csv",
        "other.export_to_csv": "export-to-csv",
        "integrations.overview": "overview-integrations",
        "integrations.gsuite": "integrations/gsuite",
        "integrations.google_calendar": "integrations/google-calendar",
        "integrations.google_drive": "integrations/google-drive",
        "integrations.gmail": "integrations/gmail",
        "integrations.email": "integrations/email",
        "integrations.dropbox": "integrations/dropbox",
        "integrations.box": "integrations/box",
        "integrations.slack": "integrations/slack",
        "permissions_and_access.overview_permissions": "overview-permissions",
        "permissions_and_access.organization_users": "organization-users",
        "permissions_and_access.project_users": "project-users",
        "analytics.tasks": "analytics/tasks",
        "analytics.time": "analytics/time",
        "analytics.communication": "analytics/communication",
        "analytics.behavior": "analytics/behavior",
        "analytics.reports": "analytics/reports",
        "analytics.manage": "analytics/manage",
        "apps.ios": "apps/ios",
        "apps.android": "apps/android",
        "apps.desktop": "apps/desktop",
        "user.work-week": "users/settings",
    },
    sections: {
        "my_work": "my-work",
        "folders": "folders",
        "events": "events",
        "views": "views",
        "organization_management": "organization-managment",
        "integrations": "integrations",
        "permissions_and_access": "permissions_and_access",
        "notifications": "notifications",
        "tasks": "tasks",
        "time_tracking": "time-tracking",
        "big_screens": "big-screens",
        "other": "other",
        "customization": "customization",
        "apps": "apps",
        "users": "users",
        "my_account": "my-account",
        "analytics": "analytics"
    },
    videoTutorials: {
        MY_WORK_ACTION_REQUIRED: 'mwar',
        'mwar': {
            id: 'mwar',
            title: 'My work & action required',
            timing: '2:11',
            preview: '/app/static/videos/mw-ar/small.png',
            videoId: '1YdLkZaLhUo'
        },

        'gantt': {
            id: 'gantt',
            title: 'Working with Gantt chart',
            timing: '5:37',
            preview: '/app/static/videos/gantt/small.png',
            videoId: 'Y5qSGw2PFqg'
        },

        PROJECT_TASK_LIST: 'ptl',
        'ptl': {
            id: 'ptl',
            title: 'Task list',
            timing: '4:09',
            preview: '/app/static/videos/task-list/small.png',
            videoId: 'h-KY7wd2ptM'
        },

    }
};